<template>
	<div class="profile-page">
		<div class="pageFrom animate__animated  ">
			<!-- 页面标题 -->
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31224_6124/20.svg')"></el-image>
				<span>{{$t('uinfo.t1')}}</span>
			</div>

			<!-- 头像区域 -->
			<div class="avatar-section">
				<div class="avatar-info">
					<span class="avatar-label">{{$t('uinfo.t2')}}</span>
				</div>
				<el-upload accept="image/png, image/jpeg"
					class="avatar-uploader"
					:action="uplink"
					:show-file-list="false"
					:on-change="uplinkportrait">
					<el-image class="avatar-img" :src="portrait"></el-image>
				</el-upload>
			</div>

			<!-- 表单区域：两列布局 -->
			<div class="form-container">

				<!-- 左列 -->
				<div class="form-col">
					<!-- 昵称 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t3')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="name" :placeholder="$t('uinfo.t4')"></el-input>
						</div>
					</div>

					<!-- 国家 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t5')}}</label>
						<div class="form-input-wrap1 country-field">
							<div class="country-trigger" @click="toggleCountryPanel">
								<span v-if="selectedCountryName" class="country-trigger-value">{{selectedCountryName}}</span>
								<span v-else class="country-trigger-placeholder">{{$t('uinfo.t6')}}</span>
								<i class="el-icon-arrow-down country-trigger-arrow" :class="{ 'arrow-up': showCountryPanel }"></i>
							</div>
							<!-- 国家弹出选择面板：搜索框 + 字母索引 -->
							<div class="country-panel" v-show="showCountryPanel" @click.stop>
								<div class="country-search">
									<el-input v-model="searchKeyword" :placeholder="$t('uinfo.t26')" class="country-search-input" clearable>
										<i slot="prefix" class="el-icon-search"></i>
									</el-input>
								</div>
								<div class="country-body">
									<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
										<template v-for="group in filteredCountries">
											<div class="country-group" :key="group.letter" :data-letter="group.letter">
												<div class="country-group-title">{{group.letter}}</div>
												<div class="country-item" :class="{ active: countryIdx === item.value }" v-for="item in group.items" :key="item.value" @click="selectCountry(item)">
													<!-- 多语言 -->
													<template v-if="$i18n.locale=='zh'">
														<span class="country-name">{{item.name}}</span>
													</template>
													<template v-if="$i18n.locale=='en'">
														<span class="country-name">{{item.nameEn}}</span>
													</template>
												</div>
											</div>
										</template>
										<div v-if="filteredCountries.length === 0" class="country-empty">{{$t('uinfo.t27')}}</div>
									</div>
									<div class="country-index">
										<span v-for="letter in availableLetters" :key="letter" class="country-index-item" :class="{ active: activeLetter === letter }" @click="scrollToLetter(letter)">{{letter}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 手机号码 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t7')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="mobile" :disabled="ismobile?true:false" :placeholder="$t('uinfo.t8')" ></el-input>
						</div>
						<div class="bangdin" v-if="!ismobile" @click="openAddDialog(1)">{{$t('uinfo.t9')}}</div>
					</div>

					<!-- 微信 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t10')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="wechat" :placeholder="$t('uinfo.t11')"></el-input>
						</div>
					</div>
				</div>

				<!-- 右列 -->
				<div class="form-col">
					<!-- 性别 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t12')}}</label>
						<div class="form-input-wrap gender-input">
							
							<div class="item f-ct" @click="gender = 1">
								<el-image v-show="gender==1" :src="require('@/static/sel/1.svg')"></el-image>
								<el-image v-show="gender!=1" :src="require('@/static/sel/2.svg')"></el-image>
								<span>{{$t('uinfo.sex1')}}</span>
							</div>
							
							<div class="item f-ct" @click="gender = 2">
								<el-image v-show="gender==2" :src="require('@/static/sel/1.svg')"></el-image>
								<el-image v-show="gender!=2" :src="require('@/static/sel/2.svg')"></el-image>
								<span>{{$t('uinfo.sex2')}}</span>
							</div>
							
						</div>
					</div>

					<!-- 城市 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t13')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="cityName" :placeholder="$t('uinfo.t14')"></el-input>
						</div>
					</div>

					<!-- 邮箱 -->
					<div class="form-item">
						<label class="form-label">{{$t('uinfo.t15')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="email" :disabled="isemail?true:false" :placeholder="$t('uinfo.t16')"></el-input>
						</div>
						<div class="bangdin" v-if="!isemail" @click="openAddDialog(2)">{{$t('uinfo.t9')}}</div>
					</div>

					<!-- whatsapp -->
					<div class="form-item">
						<label class="form-label">whatsapp</label>
						<div class="form-input-wrap">
							<el-input v-model="whatsapp" :placeholder="$t('uinfo.t17')"></el-input>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 保存按钮 -->
		<div class="action-bar animate__animated  ">
			<button class="save-btn" @click="submit">{{$t('uinfo.t18')}}</button>
		</div>
		
		<!-- 绑定弹出框 -->
		<el-dialog
			:visible.sync="addMarkVisible"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false"
			@close="handleCloseDialog">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title" v-if="bdType==1">{{$t('uinfo.t19')}}</h2>
				<h2 class="dialog-title" v-if="bdType==2">{{$t('uinfo.t20')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisible = false"></el-image>
			</div>
			<!-- 弹窗内容区 -->
			<div class="dialog-body">
				
				<div class="form-field" v-if="bdType==1">
					<label class="field-label">{{$t('uinfo.t7')}}</label>
					<el-input
						v-model="bdIpt"
						class="field-input"
						:placeholder="$t('uinfo.t8')"
						clearable
					></el-input>
				</div>
				
				<div class="form-field" v-if="bdType==2">
					<label class="field-label">{{$t('uinfo.t15')}}</label>
					<el-input
						v-model="bdIpt"
						class="field-input"
						:placeholder="$t('uinfo.t16')"
						clearable
					></el-input>
				</div>
				<div class="form-field">
					<label class="field-label">{{$t('uinfo.t21')}}</label>
					<el-input
						v-model="code"
						class="field-input"
						:placeholder="$t('uinfo.t22')"
						clearable
					></el-input>
					<div class="getCode" @click="startCountdown">{{ counting ? countdown + 's' : $t('uinfo.t23') }}</div>
				</div>
		
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisible = false">{{$t('uinfo.t24')}}</button>
				<button class="btn-confirm" @click="handleConfirm">{{$t('uinfo.t25')}}</button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		authMemberinfo,
		countrylist,
		authMemberprofile,
		smsemail,
		smsmobile,
		authMemberbindMobile,
		authMemberbindEmail
	} from "/src/api/api.js"
	// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
	const CN_FIRST_LETTER = {
		'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
		'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
		'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
		'布': 'B',
		'赤': 'C',
		'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
		'俄': 'E', '厄': 'E',
		'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
		'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
		'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
		'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
		'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
		'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
		'列': 'L', '卢': 'L', '罗': 'L',
		'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
		'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
		'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
		'帕': 'P', '葡': 'P',
		'日': 'R', '瑞': 'R',
		'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
		'索': 'S',
		'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
		'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
		'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
		'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
		'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
		'赞': 'Z', '智': 'Z', '中': 'Z'
	}
	export default {
		name: 'UserProfile',
		data() {
			return {
				iconSel: require('@/static/sel/1.svg'),
				iconUnsel: require('@/static/sel/2.svg'),
				// 用户数据
				accountType:'',
				portrait:'',
				name:'',
				gender:'',
				mobile:'',
				ismobile:'',
				email:'',
				isemail:'',
				cityName:'',
				whatsapp:'',
				wechat:'',
				// 国家
				countryId:0,
				countryArr:[],
				countryIdx:0,
				// 国家选择面板
				searchKeyword: '',
				showCountryPanel: false,
				activeLetter: '',
				// 版本
				version:0,
				// 弹出框
				bdType:1,
				addMarkVisible: false,
				bdIpt:'',
				// 验证码
				code: '',
				countdown: 0,
				counting: false,
				timer: null,
			}
		},
		computed: {
			// 当前选中国家名称
			selectedCountryName() {
				const item = this.countryArr[this.countryIdx]
				// 多语言
				if(this.$i18n.locale=='zh'){
					return item ? (item.label || item.name) : ''
				}
				if(this.$i18n.locale=='en'){
					return item ? (item.nameEn || item.name) : ''
				}
			},
			// 按首字母分组 + 搜索过滤后的列表
			filteredCountries() {
				const kw = this.searchKeyword.trim().toLowerCase()
				let list = this.countryArr
				if (kw) {
					list = list.filter(item => String(item.label || item.name || '').toLowerCase().indexOf(kw) > -1)
				}
				return this.groupByLetter(list)
			},
			// 字母索引条：基于全部国家（不随搜索变化）
			availableLetters() {
				const set = []
				this.countryArr.forEach(item => {
					const l = this.getFirstLetter(item.label || item.name)
					if (set.indexOf(l) === -1) set.push(l)
				})
				return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			}
		},
		mounted() {
			this.getinfo()
			document.addEventListener('click', this.handleDocumentClick)
		},
		beforeDestroy() {
			document.removeEventListener('click', this.handleDocumentClick)
		},
		methods: {
			// ===== 国家选择面板相关 =====
			// 切换面板显示状态
			toggleCountryPanel() {
				this.showCountryPanel = !this.showCountryPanel
				if (this.showCountryPanel) {
					this.searchKeyword = ''
					this.activeLetter = ''
				}
			},
			// 选中国家（countryIdx 为下标索引）
			selectCountry(item) {
				this.countryIdx = item.value
				this.showCountryPanel = false
				this.searchKeyword = ''
			},
			// 点击字母索引，锚定滚动到对应分组
			scrollToLetter(letter) {
				this.activeLetter = letter
				const listEl = this.$refs.countryList
				if (!listEl) return
				const target = listEl.querySelector(`[data-letter="${letter}"]`)
				if (target) {
					listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
				}
			},
			// 列表滚动时高亮当前所在字母
			onCountryListScroll() {
				const listEl = this.$refs.countryList
				if (!listEl) return
				const scrollTop = listEl.scrollTop
				let current = ''
				listEl.querySelectorAll('[data-letter]').forEach(el => {
					if (el.offsetTop <= scrollTop + 1) {
						current = el.getAttribute('data-letter')
					}
				})
				this.activeLetter = current
			},
			// 提取首字母（兼容英文/中文，无法识别归入 #）
			getFirstLetter(name) {
				if (!name) return '#'
				const first = String(name).trim().charAt(0)
				if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
				if (/[\u4e00-\u9fa5]/.test(first)) {
					return CN_FIRST_LETTER[first] || '#'
				}
				return '#'
			},
			// 按首字母分组
			groupByLetter(list) {
				const groups = {}
				list.forEach(item => {
					const letter = this.getFirstLetter(item.label || item.name)
					if (!groups[letter]) groups[letter] = []
					groups[letter].push(item)
				})
				const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
				return letters.map(l => ({ letter: l, items: groups[l] }))
			},
			// 点击面板外部关闭
			handleDocumentClick(e) {
				if (!this.showCountryPanel) return
				const field = this.$el.querySelector('.country-field')
				if (field && !field.contains(e.target)) {
					this.showCountryPanel = false
				}
			},
			// 验证码
			async startCountdown() {
				if (this.counting) return;
				var res;
				// var isEmail =  this.$regular.isEmail(this.account)
				if(this.bdType==1){
					if(this.bdIpt){
						res = await smsmobile({mobile:this.bdIpt});
					}else{
						this.Tips(this.$t('uinfo.t8'),'error')
					}
				}else{
					if(this.bdIpt){
						res = await smsemail({email:this.bdIpt});
					}else{
						this.Tips(this.$t('uinfo.t16'),'error')
					}
				}
				if(res.code==200){
					this.counting = true;
					this.countdown = 120;
					this.timer = setInterval(() => {
						this.countdown--;
						if (this.countdown <= 0) {
							this.counting = false;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000);
				}else{this.Tips(res.msg,'error')}
			},
			// 打开绑定弹出框
			openAddDialog(type) {
				this.bdType = type
				this.bdIpt = ''
				this.addMarkVisible = true
			},
			// 关闭弹窗时重置表单
			handleCloseDialog() {
				this.addMarkVisible = false
			},
			// 提交绑定
			async handleConfirm(){
				var res;
				if(this.bdType==1){
					res = await authMemberbindMobile({
						mobile:this.bdIpt,
						code:this.code,
					});
				}else{
					res = await authMemberbindEmail({
						email:this.bdIpt,
						code:this.code,
					});
				}
				if(res.code==200){
					this.Tips(res.msg)
					this.addMarkVisible = false
					this.getinfoC()
				}else{this.Tips(res.msg,'error')}
			},
			// 获取用户信息
			async getinfo(){
				const res = await authMemberinfo({});
				if(res.code==200){
					this.version = res.data.version
					this.accountType = res.data.accountType
					this.portrait = res.data.portrait
					this.name = res.data.name
					this.gender = res.data.gender
					this.mobile = res.data.mobile
					this.ismobile = res.data.mobile
					this.email = res.data.email
					this.isemail = res.data.email
					this.countryId = res.data.countryId
					this.cityName = res.data.cityName
					this.whatsapp = res.data.whatsapp
					this.wechat = res.data.wechat
					this.countrylistGet()
				}else{this.Tips(res.msg,'error')}
			},
			// 国家列表(全部启用的)
			async countrylistGet(){
				const res = await countrylist({})
				if(res.code==200){
					var countryArr = []
					res.rows.forEach((item,index)=>{
						item.label = item.name
						item.value = index
						if(item.id==this.countryId){
							this.countryIdx = index
						}
						countryArr.push(item)
					})
					this.countryArr = countryArr
				}else{this.Tips(res.msg,'error')}
			},
			// 个人信息更新
			async submit(){
				const res = await authMemberprofile({
					version:this.version,
					accountType:this.accountType,
					portrait:this.portrait,
					name:this.name,
					gender:this.gender||1,
					countryId:this.countryArr[this.countryIdx].id,
					cityName:this.cityName,
					whatsapp:this.whatsapp,
					wechat:this.wechat,
				})
				if(res.code==200){
					this.Tips(res.msg)
					this.getinfoC()
					// this.back()
				}else{this.Tips(res.msg,'error')}
			},
			// 保存用户信息
			async getinfoC(){
				const res = await authMemberinfo({});
				if(res.code==200){
					this.version = res.data.version
					this.accountType = res.data.accountType
					this.portrait = res.data.portrait
					this.name = res.data.name
					this.gender = res.data.gender
					this.mobile = res.data.mobile
					this.ismobile = res.data.mobile
					this.email = res.data.email
					this.isemail = res.data.email
					this.countryId = res.data.countryId
					this.cityName = res.data.cityName
					this.whatsapp = res.data.whatsapp
					this.wechat = res.data.wechat
					this.$store.commit('userMsg/userInfoC',res.data);
				}else{this.Tips(res.msg,'error')}
			},
			// ===== 图片上传 =====
			uplinkportrait(file) {
				if(file.response){
					this.portrait = file.response.data.url;
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	/* ========== 设计令牌 ========== */
	$primary: #0096FF;
	$danger: #FC2933;
	$text-dark: #333333;
	$text-gray: #999999;
	$text-muted: #C6C6C6;
	$border-color: #D9D9D9;
	$page-bg: #F8F8F8;
	$card-bg: #FFFFFF;

	$font-lg: 0.20rem;
	$font-md: 0.16rem;
	$font-sm: 0.14rem;
	$font-xs: 0.13rem;

	/* ========== 页面容器 ========== */
	.profile-page {
		width: 100%;
		min-height: 14.04rem;
		background: $page-bg;
	}

	.pageFrom {
		width: 15.96rem;
		background: $card-bg;
		border-radius: 0.12rem;
		padding: 0.28rem 0.32rem;
		margin-top: 0.20rem;
		padding-bottom: 42px;
		box-sizing: border-box;
	}

	/* ========== 区块标题 ========== */
	.sec-title {
		display: flex;
		align-items: center;
		padding-left: 0.10rem;
		margin-bottom: 0.18rem;

		.el-image {
			width: 0.02rem;
			height: 0.20rem;
			margin-right: 0.08rem;
			display: block;
		}

		span {
			font-size: $font-lg;
			font-weight: 500;
			color: $text-dark;
		}
	}

	/* ========== 头像区域 ========== */
	.avatar-section {
		margin-bottom: 0.28rem;
		padding-left: 0.18rem;
	}

	.avatar-img {
		width: 0.90rem;
		height: 0.90rem;
		border-radius: 0.06rem;
		flex-shrink: 0;
	}

	.avatar-info {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
	}

	.avatar-label {
		font-size: 0.16rem;
		font-weight: 500;
		color: #3B3C3E;
	}

	.avatar-hint {
		font-size: 0.14rem;
		font-weight: 400;
		color: #969696;
		margin-left: 0.02rem;
	}

	/* ========== 表单容器（两列Flex布局）========== */
	.form-container {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
	}

	.form-col {
		width: 7.36rem;
	}

	/* ========== 表单项 ========== */
	.form-item {
		display: flex;
		align-items: center;
		margin-bottom: 0.22rem;
		&:last-child {
			margin-bottom: 0;
		}
		.bangdin{
			width: 0.84rem;
			height: 0.50rem;
			background: $primary;
			border: none;
			border-radius: 0.10rem;
			font-family: 'PingFang SC', sans-serif;
			font-size: 0.18rem;
			font-weight: 500;
			color: #FFFFFF;
			cursor: pointer;
			outline: none;
			text-align: center;
			line-height: 50px;
			transition: opacity 0.25s ease, transform 0.15s ease;
			margin-left: 12px;
		}
	}

	/* 标签 */
	.form-label {
		width: 0.82rem;
		text-align: right;
		font-size: 0.16rem;
		font-weight: 400;
		color: $text-dark;
		flex-shrink: 0;
		line-height: 0.50rem;
		margin-right: 0.14rem;
	}
	
	.form-input-wrap1 {
		width: 3.82rem;
		height: 0.50rem;
		border: 1px solid $border-color;
		border-radius: 0.04rem;
		
		::v-deep .el-select {
			height: 100%;
			// width: calc(100% - 24px);
			width: 100%;
		}
		::v-deep .el-input__suffix{
			display: none;
		}
		
		::v-deep .el-input {
			width: 100%;
			height: 100%;
		}
		
		::v-deep .el-input__inner {
			height: 0.48rem;
			line-height: 0.48rem;
			border: none;
			font-size: 0.16rem;
			color: $text-dark;
			padding: 0 0.16rem;
		
			&::placeholder {
				color: $text-muted;
			}
		
			&:focus {
				border-color: $primary;
			}
		
			&.is-disabled {
				color: $text-muted;
				background-color: #f5f5f5;
				cursor: not-allowed;
			}
		}
	}
		
	/* 输入框容器 */
	.form-input-wrap {
		width: 3.82rem;
		height: 0.50rem;
		
		::v-deep .el-select {
			height: 100%;
			width: calc(100% - 24px);
		}
		::v-deep .el-input__suffix{
			display: none;
		}

		::v-deep .el-input {
			width: 100%;
			height: 100%;
		}

		::v-deep .el-input__inner {
			height: 0.50rem;
			line-height: 0.50rem;
			border: 1px solid $border-color;
			border-radius: 0.04rem;
			font-size: 0.16rem;
			color: $text-dark;
			padding: 0 0.16rem;

			&::placeholder {
				color: $text-muted;
			}

			&:focus {
				border-color: $primary;
			}

			&.is-disabled {
				color: $text-muted;
				background-color: #f5f5f5;
				cursor: not-allowed;
			}
		}
	}

	/* 下拉箭头 */
	.select-arrow {
		width: 0.12rem;
		height: 0.12rem;
	}

	/* ========== 性别选择器（JS+div实现）========== */
	.gender-input {
		display: flex;
		align-items: center !important;
		padding: 0 0.16px;
		position: relative;
		border: 1px solid $border-color;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		padding-left: 26px;
		.item{
			margin-right: 52px;
			span{
				font-size: 16px;
				padding-left: 12px;
			}
		}
	}


	/* ========== 操作按钮区 ========== */
	.action-bar {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-top: 0.24rem;
	}

	.save-btn {
		width: 1.84rem;
		height: 0.60rem;
		background: $primary;
		border: none;
		border-radius: 0.10rem;
		font-family: 'PingFang SC', sans-serif;
		font-size: 0.18rem;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
		outline: none;
		transition: opacity 0.25s ease, transform 0.15s ease;

		&:hover {
			opacity: 0.88;
			transform: translateY(-0.01rem);
		}

		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
	/* ================================================================
	   添加唛头弹窗样式
	   ================================================================ */
	
	::v-deep .add-mark-dialog {
		border-radius: 8px;
		overflow: hidden;
	
		.el-dialog__header {
			padding: 0;
			margin: 0;
		}
	
		.el-dialog__body {
			padding: 30px 32px 20px;
			padding-bottom: 32px;
		}
	
		.el-dialog__footer {
			padding: 0 32px 28px;
		}
	}
	
	
	/* ---- 弹窗头部 ---- */
	.dialog-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 69px;
		background: #f7fafc;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		padding: 0 30px;
		box-sizing: border-box;
	}
	
	.dialog-title {
		font-family: 'PingFang SC', sans-serif;
		font-size: 18px;
		font-weight: 500;
		color: #2F3541;
		margin: 0;
		line-height: 1;
	}
	
	.dialog-close-icon {
		width: 16px;
		height: 16px;
		cursor: pointer;
		transition: opacity 0.25s;
	
		&:hover {
			opacity: 0.7;
		}
	}
	
	
	/* ---- 弹窗内容区 ---- */
	.dialog-body {
		display: flex;
		flex-direction: column;
	}
	
	
	/* 表单字段行 */
	.form-field {
		display: flex;
		align-items: center;
		margin: auto;
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
	}
	
	
	/* 字段标签 */
	.field-label {
		width: 80px;
		text-align: right;
		font-size: 16px;
		font-weight: 400;
		color: #9A9DA7;
		flex-shrink: 0;
		line-height: 45px;
		margin-right: 14px;
		position: relative;
		&--center {
			text-align: center;
		}
	}
	
	.getCode{
		height: 40px;
		line-height: 40px;
		text-align: right;
		padding-right: 12px;
		color: #0096FF;
		cursor: pointer;
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
	}
	
	/* 输入框 */
	.field-input {
		width: 307px;
		
		.el-input__inner {
			height: 41px;
			line-height: 41px;
			border: 2px solid #E8EDF4;
			border-radius: 8px;
			font-size: 16px;
			color: #333333;
			padding: 0 16px;
	
			&::placeholder {
				color: #999999;
			}
	
			&:focus {
				border-color: #0096FF;
			}
		}
	}
	
	
	/* ---- 自定义单选组（JS+div实现）---- */
	.radio-group {
		display: flex;
		align-items: center;
		width: 307px;
		height: 43px;
		border: 2px solid #E8EDF4;
		border-radius: 8px;
		padding: 0 16px;
		box-sizing: border-box;
		background: white;
	}
	
	
	/* 单选选项 */
	.radio-option {
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-right: 40px;
		user-select: none;
	
		&:last-child {
			margin-right: 0;
		}
	}
	
	
	/* 图标容器 */
	.radio-icon-wrap {
		position: relative;
		width: 22px;
		height: 22px;
		margin-right: 10px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	
	/* 选中图标 */
	.radio-sel-icon {
		width: 22px;
		height: 22px;
		display: block;
	}
	
	
	/* 未选中图标组合 */
	.radio-unsel-wrap {
		position: relative;
		width: 22px;
		height: 22px;
		display: block;
	}
	
	.radio-unsel-outer {
		width: 22px;
		height: 22px;
		position: absolute;
		top: 0;
		left: 0;
		display: block;
	}
	
	.radio-unsel-inner {
		width: 14px;
		height: 14px;
		position: absolute;
		top: 4px;
		left: 4px;
		display: block;
	}
	
	
	/* 选项文字 */
	.option-text {
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		line-height: 1;
	}
	
	
	/* ---- 弹窗底部按钮区 ---- */
	.dialog-footer {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 4px;
	}
	
	
	/* 返回按钮 */
	.btn-cancel {
		width: 120px;
		height: 44px;
		background: #E9F6FF;
		border: none;
		border-radius: 6px;
		font-family: 'PingFang SC', sans-serif;
		font-size: 16px;
		font-weight: 400;
		color: #0096FF;
		cursor: pointer;
		outline: none;
		transition: opacity 0.25s;
	
		&:hover {
			opacity: 0.85;
		}
	
		&:active {
			opacity: 1;
		}
	}
	
	
	/* 确认修改按钮 */
	.btn-confirm {
		width: 120px;
		height: 44px;
		background: #0096FF;
		border: none;
		border-radius: 6px;
		font-family: 'PingFang SC', sans-serif;
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
		cursor: pointer;
		outline: none;
		margin-left: 14px;
		transition: opacity 0.25s;

		&:hover {
			opacity: 0.88;
		}

		&:active {
			opacity: 1;
		}
	}

	/* ===== 国家选择面板（搜索 + 字母索引） ===== */
	.country-field {
		position: relative;
	}
	.country-trigger {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 0.16rem;
		box-sizing: border-box;
		cursor: pointer;
		font-size: $font-md;
		color: $text-dark;
		.country-trigger-placeholder {
			color: $text-muted;
		}
		.country-trigger-arrow {
			color: $text-gray;
			font-size: 0.12rem;
			transition: transform 0.3s;
			&.arrow-up {
				transform: rotate(180deg);
			}
		}
	}
	.country-panel {
		position: absolute;
		top: calc(100% + 0.06rem);
		left: 0;
		width: 6.4rem;
		background: $card-bg;
		border-radius: 0.08rem;
		box-shadow: 0 0.08rem 0.32rem rgba(0, 0, 0, 0.16);
		z-index: 999;
		padding: 0.12rem;
		box-sizing: border-box;
	}
	.country-search {
		margin-bottom: 0.12rem;
		::v-deep .el-input__inner {
			height: 0.4rem;
			border: 0.01rem solid #E2E6E9;
			border-radius: 0.04rem;
			padding-left: 0.3rem;
			font-size: $font-sm;
			color: $text-dark;
		}
		::v-deep .el-input__inner:focus {
			border-color: $primary;
		}
		::v-deep .el-input__prefix {
			left: 0.08rem;
			line-height: 0.4rem;
			color: #92969F;
		}
	}
	.country-body {
		display: flex;
		align-items: flex-start;
	}
	.country-list {
		flex: 1;
		height: 3.2rem;
		overflow-y: auto;
		padding-right: 0.08rem;
		position: relative;
		&::-webkit-scrollbar {
			width: 4px;
		}
		&::-webkit-scrollbar-thumb {
			background: #ddd;
			border-radius: 2px;
		}
	}
	.country-group-title {
		font-size: $font-xs;
		font-weight: 600;
		color: $primary;
		padding: 0.06rem 0.1rem;
	}
	.country-item {
		padding: 0.08rem 0.1rem;
		font-size: $font-sm;
		color: $text-dark;
		cursor: pointer;
		border-radius: 0.04rem;
		transition: background 0.2s, color 0.2s;
		&:hover {
			background: #F0F7FD;
			color: $primary;
		}
		&.active {
			background: #F0F7FD;
			color: $primary;
			font-weight: 500;
		}
	}
	.country-empty {
		text-align: center;
		color: #BFC6CE;
		font-size: $font-sm;
		padding: 0.4rem 0;
	}
	.country-index {
		width: 0.36rem;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		max-height: 3.2rem;
		overflow-y: auto;
		border-left: 0.01rem solid #F0F0F0;
	}
	.country-index-item {
		font-size: 0.12rem;
		color: #666;
		cursor: pointer;
		line-height: 1.4;
		padding: 0.01rem 0;
		transition: color 0.2s;
		&:hover,
		&.active {
			color: $primary;
			font-weight: 600;
		}
	}
</style>